import { raygun } from '@ynap/clientside-monitoring';
import { Catalogue } from '@ynap/api-utils';

export const fetchProductDetails = async ({ partNumber, baseUrl, brandId, clientId, country, langISO }) => {
    try {
        const response = await fetch(Catalogue.getDetailsByPartNumber({ baseUrl, brandId, clientId, country, partNumber, options: { locale: langISO } }));

        if (!response.ok) {
            raygun.helpers.agent('send', {
                error: new Error(`getDetailsByPartNumber in fetchProductDetails error`),
                tags: [`error-getDetailsByPartNumber`, `partNumber: ${partNumber}`, `statusCode: ${response.status}`],
            });
            return;
        }

        const json = await response.json();

        return json.products[0];
    } catch (err) {
        raygun.helpers.agent('send', {
            error: new Error(`getDetailsByPartNumber in fetchProductDetails error`),
            tags: [`error-getDetailsByPartNumber`, `partNumber: ${partNumber}`],
            customData: {
                err,
            },
        });
    }
};
